
/**
 * Set a setting within the theme settings cookie.
 *
 * @param {string} theme_cookie_setting              Component name.
 * @param {string|object} theme_cookie_setting_data  The settings for the component.
 */
export function set_theme_cookie_setting( theme_cookie_setting, theme_cookie_setting_data ) {
	// Set expire date, advanced one year.
	let expire_date = new Date();
	expire_date.setTime( expire_date.getTime() + ( 52 * 7 * 24 * 60 * 60 * 1000 ) );

	// Put settings in JavaScript object.
	let theme_cookie_settings_json = get_theme_cookie_settings();

    // Ensure theme_cookie_settings_json is an object and not an array.
    if ( Array.isArray( theme_cookie_settings_json ) ) {
        theme_cookie_settings_json = {};
    }

	// Change setting in data from cookie.
	theme_cookie_settings_json[ theme_cookie_setting ] = theme_cookie_setting_data;

	// Stringify to store data in cookie again.
	let theme_cookie_settings_json_string = JSON.stringify( theme_cookie_settings_json );

	// Set cookie.
	document.cookie = 'theme_settings=' + theme_cookie_settings_json_string + "; expires=" + expire_date.toUTCString() + "; path=/";
}


/**
 * Set a value within a data associative array that is set as a value of a component (key) within the theme cookie settings array.
 *
 * @param {string} theme_cookie_setting                          Component name (key of theme settings cookie assoc. array/JS object).
 * @param {string} theme_cookie_nested_setting                   Key within the component associative array(/ JS object).
 * @param {string|object} theme_cookie_nested_setting_value      Value to set for the components array key.
 */
export function set_nested_theme_cookie_setting( theme_cookie_setting, theme_cookie_nested_setting, theme_cookie_nested_setting_value ) {
    // Set expire date, advanced one year.
    let expire_date = new Date();
    expire_date.setTime( expire_date.getTime() + ( 52 * 7 * 24 * 60 * 60 * 1000 ) );

    // Get settings from cookie.
    let theme_cookie_settings_json = get_theme_cookie_settings();

    // Ensure theme_cookie_settings_json is an object and not an array.
    if ( Array.isArray( theme_cookie_settings_json ) ) {
        theme_cookie_settings_json = {};
    }

    // Ensure the value for the main key is an object.
    if ( ! theme_cookie_settings_json[ theme_cookie_setting ] ||
		typeof theme_cookie_settings_json[ theme_cookie_setting ] !== 'object' ||
		Array.isArray( theme_cookie_settings_json[ theme_cookie_setting ]
	) ) {
        theme_cookie_settings_json[ theme_cookie_setting ] = {};
    }

    // Set the nested key value.
    theme_cookie_settings_json[ theme_cookie_setting ][ theme_cookie_nested_setting ] = theme_cookie_nested_setting_value;

    // Stringify to store data in cookie again.
    let theme_cookie_settings_json_string = JSON.stringify( theme_cookie_settings_json );

    // Set cookie.
    document.cookie = 'theme_settings=' + theme_cookie_settings_json_string + "; expires=" + expire_date.toUTCString() + "; path=/";
}


/**
 * Get all settings from theme settings cookie in JSON form.
 */
export function get_theme_cookie_settings() {
	let cookie_name = 'theme_settings=';
	let cookie_value = null;

	// Split the document.cookie string into individual cookies.
	let individual_cookies = document.cookie.split(';');

	// Loop through each cookie
    individual_cookies.forEach( function( cookie ) {
		// Remove any leading spaces from the cookie string.
        while ( cookie.charAt( 0 ) === ' ' ) {
            cookie = cookie.substring( 1, cookie.length );
        }

		// Check if the current cookie string starts with the name we are looking for.
        if ( cookie.indexOf( cookie_name ) === 0 ) {
            cookie_value = cookie.substring( cookie_name.length, cookie.length );
        }
    });

	// Return cookie as JavaScript object.
	return cookie_value ? JSON.parse( cookie_value ) : {};
}


/**
 * Only get data from theme cookie settings from specific component.
 *
 * @param {string} theme_cookie_setting Only return data of given component.
 * @returns
 */
export function get_theme_cookie_setting( theme_cookie_setting ) {
	let all_cookie_settings = get_theme_cookie_settings();

	// Return only the requiested component settings.
	return all_cookie_settings[ theme_cookie_setting ];
}
